import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { Image } from '../../Image';
import './AvatarChooser.css';
import get from "lodash/get";
import {getErrorMessages, sendUpload} from "../../../shared/helpers";
import {addFlashMessage, clearMessage} from "../../../store/actions/Flash";
import {updateAccountRequestFailure} from "../../../store/actions/Authentication";

export class AvatarChooser extends Component {
  state = {
    picture: undefined,
  };

  setNewAvatar = (
    e,
    field,
    form,
    updateFormInfo = null,
    submitForm = null,
    project = null,
    formInfo = null,
  ) => {
    const reader = new FileReader();
    const [file] = e.target.files;
    if (file) {
      reader.onloadend = () => {
        this.setState({ picture: reader.result });
        if (updateFormInfo) {
          sendUpload(file).then(url => {
            updateFormInfo({
              target: { name: 'projectPicture', value: url },
            });
            if (updateFormInfo)
              submitForm({
                projectData: formInfo,
                id: project.id,
              });
          });
        } else form.setFieldValue(field.name, file);
      };
      reader.readAsDataURL(file);
    }
  };

  render() {
    const {
      hideLabel,
      setHideLabel,
      name,
      label,
      pictureClassName,
      labelClassName,
      updateFormInfo,
      submitForm,
      formInfo,
      project,
      extraClassName,
    } = this.props;
    const { picture } = this.state;
    const colors = ["#FFE4F3", "#FFE2A3", "#E0F198", "#DBF4F4"]

    return (
      <Field
        name={name}
        render={({ field, form }) => (
          <div className={`text-center ${project && 'project-cover'} ${extraClassName}`}>
            {field.value ? (
              <div className={classNames('avatar-image', pictureClassName)}>
                <Image alt="avatar" src={picture || field.value} />
              </div>
            ) : (
              <div
                className={`${pictureClassName} ${project &&
                  'project-cover-pic'} ${picture ? 'edit' : 'add'}`}
                style={{
                  "backgroundColor": project && colors[project.id % 4]
                }}
              />
            )}

            <label htmlFor="avatar-chooser" className={`${labelClassName} edit-profile-pic-label`}>
              <span className="t-13 avatar-chooser__label">{label}</span>
              <input
                id="avatar-chooser"
                className="avatar-chooser__input"
                type="file"
                accept=".jpg, .jpeg, .png, .gif"
                onChange={e => {
                  if (setHideLabel) setHideLabel(true);
                  this.setNewAvatar(
                    e,
                    field,
                    form,
                    updateFormInfo,
                    submitForm,
                    project,
                    formInfo,
                  );
                }}
              />
            </label>
          </div>
        )}
      />
    );
  }
}

AvatarChooser.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  pictureClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  updateFormInfo: PropTypes.func,
  submitForm: PropTypes.func,
  formInfo: PropTypes.object,
  project: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Form/AvatarChooser/AvatarChooser.js